// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"24c52422","227":"317ffb9d","369":"a410f722","569":"a14963c8","620":"2e2849da","638":"2477b9b2","666":"67b43567","757":"b3025308","790":"58d02473","897":"bd7575b5","945":"8dd4190e","948":"09e447cd","995":"9e50ffa5"}[chunkId] + ".chunk.js";
};